<script>
export default {
  name: "BurgerMenuAcc",
  components: {
  },
  data() {
    return {

    };
  },
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    emitCloseMenu() {
      this.$emit("close-menu");
    },
  },
};
</script>

<template>
  <div class="burgermenu" :class="{ active: isActive }">
    <router-link class="burgermenu__logo">
      <svg width="140" height="41" viewBox="0 0 140 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M20.1323 40.8648C8.99733 40.8648 0 31.8355 0 20.7324C0 9.59743 9.02924 0.600098 20.1323 0.600098C31.2673 0.600098 40.2647 9.62933 40.2647 20.7324C40.2966 31.8674 31.2673 40.8648 20.1323 40.8648ZM21.8879 22.6469H18.3148V25.1995V26.22L18.2944 26.2404L18.3148 26.2609V28.8366V28.8367H34.5547V25.1995H24.479L34.5152 15.1633L31.9434 12.5914L21.8879 22.6469ZM5.75963 26.2747L15.7681 16.2663H5.71194V12.6291H18.3141V12.5967H21.9513V12.6291H21.9518V15.1689L21.9805 15.1976L21.9518 15.2263V16.2663H21.9513V18.7864H18.3918L8.33151 28.8466L5.75963 26.2747Z"
          fill="#1A1A1A" />
        <path
          d="M59.0896 10.4904C56.7605 10.4904 55.58 10.9052 55.58 11.7347C55.58 12.1176 55.7714 12.3728 56.1224 12.5643C56.4734 12.7238 57.1115 12.8514 58.0367 12.9152L61.1954 13.1067C63.1097 13.2662 64.5135 13.6171 65.375 14.1914C66.2364 14.7657 66.6831 15.5953 66.6831 16.7439C66.6831 18.0839 66.045 19.1368 64.7688 19.8706C63.4925 20.6044 61.6101 20.9554 59.1534 20.9554C56.8562 20.9554 55.1014 20.6364 53.9209 20.0301C52.7404 19.392 51.9747 18.403 51.5918 16.9991L55.1014 16.4886C55.2609 17.1587 55.6757 17.6691 56.3138 17.9882C56.9519 18.3073 57.8772 18.4668 59.0577 18.4668C61.6739 18.4668 63.014 18.0201 63.014 17.1587C63.014 16.7439 62.8544 16.4567 62.5035 16.2972C62.1525 16.1377 61.5782 16.0101 60.6849 15.9143L57.4943 15.7229C55.6119 15.5953 54.2081 15.2124 53.3147 14.6062C52.4213 14 51.9747 13.1386 51.9747 12.0219C51.9747 10.7776 52.5809 9.78849 53.8252 9.08657C55.0695 8.38465 56.7924 8.03369 59.0258 8.03369C61.2273 8.03369 62.9182 8.35274 64.1307 8.95895C65.3112 9.56515 66.0769 10.5223 66.3959 11.7666L62.9182 12.2771C62.7906 11.6709 62.4077 11.2242 61.8015 10.9371C61.1953 10.6499 60.302 10.4904 59.0896 10.4904Z"
          fill="#1A1A1A" />
        <path
          d="M76.9562 20.9873C74.3719 20.9873 72.3299 20.413 70.8942 19.2644C69.4265 18.1158 68.7246 16.5205 68.7246 14.5105C68.7246 12.5005 69.4584 10.9052 70.8942 9.75658C72.3618 8.60799 74.3719 8.03369 76.9562 8.03369C79.5405 8.03369 81.5825 8.60799 83.0182 9.75658C84.454 10.9052 85.1878 12.5005 85.1878 14.5105C85.1878 16.5524 84.454 18.1477 83.0182 19.2963C81.5825 20.413 79.5724 20.9873 76.9562 20.9873ZM76.9562 18.1477C79.9234 18.1477 81.3911 16.9353 81.3911 14.5105C81.3911 12.0857 79.9234 10.8733 76.9562 10.8733C73.989 10.8733 72.5214 12.0857 72.5214 14.5105C72.5214 16.9353 73.989 18.1477 76.9562 18.1477Z"
          fill="#1A1A1A" />
        <path
          d="M91.6014 20.732H88.2832V3.6626H92.0162V10.3947C92.6543 9.62892 93.4519 9.05462 94.441 8.63985C95.43 8.22508 96.5148 8.00174 97.7272 8.00174C99.8649 8.00174 101.588 8.57604 102.832 9.75654C104.076 10.937 104.715 12.5004 104.715 14.4786C104.715 16.4567 104.076 18.052 102.832 19.2006C101.588 20.3811 99.8649 20.9554 97.7272 20.9554C96.451 20.9554 95.3343 20.732 94.3133 20.2853C93.2924 19.8387 92.4628 19.2006 91.8247 18.4029L91.6014 20.732ZM96.5786 18.0839C98.0144 18.0839 99.0992 17.7648 99.833 17.1586C100.567 16.5205 100.95 15.659 100.95 14.5105C100.95 13.3619 100.567 12.4685 99.833 11.8623C99.0992 11.2561 98.0144 10.9051 96.5786 10.9051C95.1429 10.9051 94.0262 11.2242 93.2285 11.8623C92.4309 12.5004 92.0162 13.3938 92.0162 14.5105C92.0162 15.6271 92.4309 16.5205 93.2285 17.1586C94.0262 17.7648 95.1429 18.0839 96.5786 18.0839Z"
          fill="#1A1A1A" />
        <path
          d="M115.211 20.9873C112.627 20.9873 110.617 20.413 109.117 19.2325C107.65 18.0839 106.916 16.4886 106.916 14.4786C106.916 12.5324 107.65 10.969 109.117 9.78849C110.585 8.60799 112.595 8.03369 115.148 8.03369C116.775 8.03369 118.179 8.28893 119.391 8.76751C120.603 9.24609 121.529 9.97992 122.199 10.9052C122.869 11.8304 123.188 12.9152 123.188 14.1595C123.188 14.5743 123.124 14.9891 123.028 15.4358H110.617C110.968 17.3501 112.499 18.3073 115.211 18.3073C117.636 18.3073 119.04 17.733 119.455 16.5525L123.06 17.1906C122.645 18.4987 121.784 19.4558 120.54 20.094C119.295 20.6682 117.541 20.9873 115.211 20.9873ZM115.18 10.6818C112.659 10.6818 111.159 11.5114 110.713 13.2024H119.519C119.136 11.5114 117.668 10.6818 115.18 10.6818Z"
          fill="#1A1A1A" />
        <path
          d="M132.408 10.4904C130.079 10.4904 128.898 10.9052 128.898 11.7347C128.898 12.1176 129.09 12.3728 129.441 12.5643C129.792 12.7238 130.43 12.8514 131.355 12.9152L134.514 13.1067C136.428 13.2662 137.832 13.6171 138.693 14.1914C139.555 14.7657 140.001 15.5953 140.001 16.7439C140.001 18.0839 139.363 19.1368 138.087 19.8706C136.811 20.6044 134.928 20.9554 132.472 20.9554C130.175 20.9554 128.42 20.6364 127.239 20.0301C126.059 19.392 125.293 18.403 124.91 16.9991L128.42 16.4886C128.579 17.1587 128.994 17.6691 129.632 17.9882C130.27 18.3073 131.196 18.4668 132.376 18.4668C134.992 18.4668 136.332 18.0201 136.332 17.1587C136.332 16.7439 136.173 16.4567 135.822 16.2972C135.471 16.1377 134.897 16.0101 134.003 15.9143L130.813 15.7229C128.93 15.5953 127.526 15.2124 126.633 14.6062C125.74 14 125.293 13.1386 125.293 12.0219C125.293 10.7776 125.899 9.78849 127.144 9.08657C128.388 8.38465 130.111 8.03369 132.344 8.03369C134.546 8.03369 136.237 8.35274 137.449 8.95895C138.63 9.56515 139.395 10.5223 139.714 11.7666L136.237 12.2771C136.109 11.6709 135.726 11.2242 135.12 10.9371C134.546 10.6499 133.62 10.4904 132.408 10.4904Z"
          fill="#1A1A1A" />
        <path d="M52.1016 30.6226V29.9526H55.8983V30.6226H54.3668V33.9408H53.633V30.6226H52.1016Z" fill="#1A1A1A" />
        <path
          d="M57.4936 35.6639H56.7598V29.9528H57.4936V30.3676C57.8126 30.0166 58.2593 29.8252 58.8336 29.8252C59.4717 29.8252 59.9503 30.0166 60.3013 30.4314C60.6522 30.8462 60.8436 31.3248 60.8436 31.899C60.8436 32.4733 60.6522 32.9838 60.3013 33.3667C59.9503 33.7815 59.4398 33.9729 58.8336 33.9729C58.2593 33.9729 57.8126 33.7815 57.4936 33.4305V35.6639ZM57.8765 30.91C57.6212 31.1652 57.4936 31.4843 57.4936 31.9629C57.4936 32.4095 57.6212 32.7605 57.8765 33.0157C58.1317 33.271 58.4508 33.3667 58.8336 33.3667C59.2165 33.3667 59.5036 33.2391 59.7589 32.9519C60.0141 32.6648 60.1098 32.3457 60.1098 31.9629C60.1098 31.58 59.9822 31.229 59.7589 30.9738C59.5355 30.7186 59.2165 30.559 58.8336 30.559C58.4508 30.5271 58.1317 30.6547 57.8765 30.91Z"
          fill="#1A1A1A" />
        <path
          d="M63.5556 29.8574C64.1299 29.8574 64.5766 29.985 64.9276 30.2722C65.2785 30.5593 65.438 30.9103 65.438 31.4208V33.9413H64.7042V33.5265C64.3852 33.8775 63.9066 34.0689 63.3323 34.0689C62.8537 34.0689 62.4708 33.9413 62.1518 33.718C61.8646 33.4946 61.7051 33.1756 61.7051 32.7289C61.7051 32.2822 61.8646 31.9632 62.1837 31.7398C62.5027 31.5484 62.9175 31.4208 63.428 31.4208H64.6723C64.6723 30.8146 64.2894 30.5274 63.5237 30.5274C63.2685 30.5274 63.0451 30.5912 62.8537 30.687C62.6623 30.7827 62.5027 30.9422 62.4389 31.1017H61.6094C61.7051 30.7189 61.9604 30.3998 62.3113 30.1765C62.6623 29.9531 63.077 29.8574 63.5556 29.8574ZM64.7042 32.346V32.0908H63.4599C62.7899 32.0908 62.4708 32.3141 62.4708 32.7289C62.4708 33.1437 62.7899 33.367 63.428 33.367C63.8109 33.367 64.1299 33.2713 64.3852 33.0799C64.5766 32.8884 64.7042 32.6332 64.7042 32.346Z"
          fill="#1A1A1A" />
        <path
          d="M69.809 29.9526H70.5429V33.9089H69.809V32.2498H67.4799V33.9089H66.7461V29.9526H67.4799V31.5798H69.809V29.9526Z"
          fill="#1A1A1A" />
        <path
          d="M75.5845 31.1014H74.7869C74.5636 30.7185 74.2126 30.5271 73.734 30.5271C73.3511 30.5271 73.0321 30.6547 72.7768 30.9419C72.5216 31.1971 72.394 31.5481 72.394 31.931C72.394 32.3457 72.5216 32.6648 72.7768 32.92C73.0321 33.1753 73.3511 33.3348 73.734 33.3348C74.2126 33.3348 74.5636 33.1434 74.7869 32.7605H75.5845C75.425 33.1434 75.2017 33.4624 74.8826 33.6858C74.5635 33.9091 74.1807 34.0367 73.734 34.0367C73.1597 34.0367 72.6492 33.8453 72.2664 33.4305C71.8835 33.0476 71.6602 32.5372 71.6602 31.931C71.6602 31.3248 71.8516 30.8462 72.2664 30.4314C72.6492 30.0485 73.1597 29.8252 73.734 29.8252C74.1807 29.8252 74.5635 29.9528 74.8826 30.1762C75.2017 30.4314 75.4569 30.7185 75.5845 31.1014Z"
          fill="#1A1A1A" />
        <path
          d="M78.9027 28.166H79.6365V29.9527H80.0194C80.6256 29.9527 81.1361 30.1442 81.5189 30.527C81.9018 30.9099 82.1251 31.3566 82.1251 31.9309C82.1251 32.5371 81.9337 33.0157 81.5508 33.3666C81.168 33.7176 80.6575 33.909 80.0194 33.909H79.6365V35.6638H78.9027V33.909H78.5198C77.8498 33.909 77.3393 33.7176 76.9884 33.3666C76.6055 33.0157 76.4141 32.5371 76.4141 31.9309C76.4141 31.3566 76.6055 30.878 77.0203 30.527C77.4031 30.1442 77.9136 29.9527 78.5198 29.9527H78.9027V28.166ZM78.9027 30.6227H78.5198C78.105 30.6227 77.7541 30.7504 77.4989 31.0056C77.2436 31.2609 77.116 31.5799 77.116 31.9628C77.116 32.3456 77.2436 32.6647 77.467 32.9199C77.6903 33.1752 78.0412 33.3028 78.4879 33.3028H78.8708V30.6227H78.9027ZM80.0194 30.6227H79.6365V33.2709H80.0194C80.4661 33.2709 80.817 33.1433 81.0404 32.888C81.2637 32.6328 81.3913 32.3137 81.3913 31.9309C81.3913 31.548 81.2637 31.229 81.0085 30.9737C80.7851 30.7504 80.4342 30.6227 80.0194 30.6227Z"
          fill="#1A1A1A" />
        <path
          d="M85.0602 33.3345C85.5388 33.3345 85.8897 33.143 86.1131 32.7921H86.9107C86.7831 33.1749 86.5278 33.4621 86.2088 33.6854C85.8897 33.9088 85.5069 34.0045 85.0602 34.0045C84.454 34.0045 83.9754 33.8131 83.5606 33.3983C83.1778 33.0154 82.9863 32.5049 82.9863 31.8987C82.9863 31.2925 83.1778 30.8139 83.5606 30.3992C83.9435 29.9844 84.4221 29.793 85.0283 29.793C85.5707 29.793 86.0493 29.9844 86.4321 30.3673C86.815 30.7501 86.9745 31.2287 86.9745 31.803C86.9745 31.9625 86.9745 32.0902 86.9426 32.1221H83.7521C83.784 32.4411 83.9435 32.7283 84.1988 32.9197C84.454 33.2388 84.7411 33.3345 85.0602 33.3345ZM85.0283 30.5268C84.6773 30.5268 84.4221 30.6225 84.1669 30.8139C83.9435 31.0054 83.8159 31.2606 83.7521 31.5797H86.1769C86.145 31.2606 86.0174 31.0054 85.794 30.8139C85.6026 30.6225 85.3473 30.5268 85.0283 30.5268Z"
          fill="#1A1A1A" />
        <path
          d="M88.8256 35.6639H88.0918V29.9528H88.8256V30.3676C89.1447 30.0166 89.5914 29.8252 90.1657 29.8252C90.8038 29.8252 91.2823 30.0166 91.6333 30.4314C91.9843 30.8462 92.1757 31.3248 92.1757 31.899C92.1757 32.4733 91.9843 32.9838 91.6333 33.3667C91.2823 33.7815 90.7719 33.9729 90.1657 33.9729C89.5914 33.9729 89.1447 33.7815 88.8256 33.4305V35.6639ZM89.2085 30.91C88.9532 31.1652 88.8256 31.4843 88.8256 31.9629C88.8256 32.4095 88.9532 32.7605 89.2085 33.0157C89.4637 33.271 89.7828 33.3667 90.1657 33.3667C90.5485 33.3667 90.8357 33.2391 91.0909 32.9519C91.3462 32.6648 91.4419 32.3457 91.4419 31.9629C91.4419 31.58 91.3143 31.229 91.0909 30.9738C90.8676 30.7186 90.5485 30.559 90.1657 30.559C89.7828 30.5271 89.4637 30.6547 89.2085 30.91Z"
          fill="#1A1A1A" />
        <path
          d="M97.3443 31.2927L96.0681 33.9089H95.3343L94.0581 31.2927V33.9089H93.3242V29.9526H94.1538L95.7171 33.1432L97.2805 29.9526H98.11V33.9089H97.3762V31.2927H97.3443Z"
          fill="#1A1A1A" />
        <path
          d="M101.044 29.8574C101.618 29.8574 102.065 29.985 102.416 30.2722C102.767 30.5593 102.926 30.9103 102.926 31.4208V33.9413H102.193V33.5265C101.873 33.8775 101.395 34.0689 100.821 34.0689C100.342 34.0689 99.9591 33.9413 99.6401 33.718C99.3529 33.4946 99.1934 33.1756 99.1934 32.7289C99.1934 32.2822 99.3529 31.9632 99.672 31.7398C99.991 31.5484 100.406 31.4208 100.916 31.4208H102.161C102.161 30.8146 101.778 30.5274 101.012 30.5274C100.757 30.5274 100.533 30.5912 100.342 30.687C100.151 30.7827 99.991 30.9422 99.9272 31.1017H99.0977C99.1934 30.7189 99.4486 30.3998 99.7996 30.1765C100.182 29.9531 100.597 29.8574 101.044 29.8574ZM102.193 32.346V32.0908H100.948C100.278 32.0908 99.9591 32.3141 99.9591 32.7289C99.9591 33.1437 100.278 33.367 100.916 33.367C101.299 33.367 101.618 33.2713 101.873 33.0799C102.097 32.8884 102.193 32.6332 102.193 32.346Z"
          fill="#1A1A1A" />
        <path
          d="M104.968 35.6639H104.234V29.9528H104.968V30.3676C105.287 30.0166 105.734 29.8252 106.308 29.8252C106.946 29.8252 107.425 30.0166 107.776 30.4314C108.127 30.8462 108.318 31.3248 108.318 31.899C108.318 32.4733 108.127 32.9838 107.776 33.3667C107.425 33.7815 106.914 33.9729 106.308 33.9729C105.734 33.9729 105.287 33.7815 104.968 33.4305V35.6639ZM105.351 30.91C105.096 31.1652 104.968 31.4843 104.968 31.9629C104.968 32.4095 105.096 32.7605 105.351 33.0157C105.606 33.271 105.925 33.3667 106.308 33.3667C106.691 33.3667 106.978 33.2391 107.233 32.9519C107.489 32.6648 107.584 32.3457 107.584 31.9629C107.584 31.58 107.457 31.229 107.233 30.9738C107.01 30.7186 106.691 30.559 106.308 30.559C105.925 30.5271 105.606 30.6547 105.351 30.91Z"
          fill="#1A1A1A" />
        <path
          d="M109.436 29.9526H110.169V31.6755L112.084 29.9526H113.073L110.871 31.9308L113.073 33.9089H112.084L110.169 32.2817V33.9089H109.436V29.9526Z"
          fill="#1A1A1A" />
        <path
          d="M115.593 33.3345C116.072 33.3345 116.423 33.143 116.646 32.7921H117.444C117.316 33.1749 117.061 33.4621 116.742 33.6854C116.423 33.9088 116.04 34.0045 115.593 34.0045C114.987 34.0045 114.509 33.8131 114.094 33.3983C113.711 33.0154 113.52 32.5049 113.52 31.8987C113.52 31.2925 113.711 30.8139 114.094 30.3992C114.477 29.9844 114.955 29.793 115.561 29.793C116.104 29.793 116.582 29.9844 116.965 30.3673C117.348 30.7501 117.508 31.2287 117.508 31.803C117.508 31.9625 117.508 32.0902 117.476 32.1221H114.285C114.317 32.4411 114.477 32.7283 114.732 32.9197C114.955 33.2388 115.242 33.3345 115.593 33.3345ZM115.53 30.5268C115.179 30.5268 114.923 30.6225 114.668 30.8139C114.445 31.0054 114.317 31.2606 114.253 31.5797H116.678C116.646 31.2606 116.519 31.0054 116.295 30.8139C116.136 30.6225 115.849 30.5268 115.53 30.5268Z"
          fill="#1A1A1A" />
        <path d="M117.986 30.6226V29.9526H121.783V30.6226H120.252V33.9408H119.518V30.6226H117.986Z" fill="#1A1A1A" />
      </svg>
    </router-link>
    <div class="burgermenu__menu">
      <a >О компании</a>
      <a >Защита персональных данных</a>
      <a >Партнерам</a>
      <a >Инвесторам</a>
      <a >Условия оказания услуг</a>
    </div>
    <div class="burgermenu__menu">
      <a >Для организаций</a>
      <a >Для ВУЗов и онлайн-школ</a>
      <a >Для сотрудников</a>
      <a >Каталог компаний</a>
      <a >Школа HR-агентов</a>
    </div>
    <div class="burgermenu__menu">
      <a >Пользовательское соглашение</a>
      <a >Комиссия спорных вопросов</a>
      <a >Официальный сайт Ростелеком</a>
      <a >IT-компания Wonderplace</a>
    </div>
    <div class="burgermenu__contact">
      <div class="burgermenu__contact-item">
        <a  class="burgermenu__contact-item-top">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
              stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10" />
            <g opacity="0.4">
              <path d="M15.5 6H20.5" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M18 8.5V3.5" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </svg>
          <div><span>8 (800)</span> 555 66 80</div>
        </a>
        <a  class="burgermenu__contact-item-bot">
          Круглосуточная поддержка
        </a>
      </div>
      <div class="burgermenu__contact-item">
        <a  class="burgermenu__contact-item-top">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7" stroke="#1A1A1A"
              stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9" stroke="#1A1A1A"
              stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M2 16.5H8" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M2 12.5H5" stroke="#1A1A1A" stroke-width="1.5" stroke-miterlimit="10"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div><span>info</span>@hrsetka.ru</div>
        </a>
        <a  class="burgermenu__contact-item-bot">
          Круглосуточная поддержка
        </a>
      </div>
    </div>
  </div>
  <div class="burgermenu-overlay" :class="{ active: isActive }" @click="emitCloseMenu"></div>
</template>

<style lang="scss" scoped>
.burgermenu {
  padding: 140px 30px 60px;
  background: #fff;
  position: fixed;
  right: -100vw;
  top: 0;
  height: 100vh;
  width: 525px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow-y: auto;
  transition: .3s all;
  &.active {
    right: 0;
  }
  &__logo {
    margin-bottom: 25px;
  }

  &__menu {
    display: flex;
    flex-direction: column;
    gap: 25px;
    padding: 25px 0;
    border-bottom: 1px solid rgba(231, 236, 238, 1);
    &:nth-child(4){
      border: none;
    }
    a {
      font-family: Aeroport;
      font-size: 16px;
      font-weight: 300;
      line-height: 21.87px;
      text-align: right;
      color: rgba(30, 31, 34, 1);
      transition: .3s all;

      &:hover {
        color: rgba(119, 0, 255, 1);
      }
    }
  }

  &__contact {
    display: flex;
    gap: 35px;
    align-items: center;
    padding-top: 25px;
  }

  &__contact-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__contact-item-top {
    font-family: Aeroport;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: rgba(26, 26, 26, 1);
    display: flex;
    align-items: center;
    gap: 10px;

    span {
      font-size: 14px;
      font-weight: 300;
    }
  }

  &__contact-item-bot {
    font-family: Aeroport;
    font-size: 14px;
    font-weight: 300;
    line-height: 19.14px;
    text-align: left;
    text-decoration: underline;
    color: rgba(128, 135, 156, 1);
  }
}

.burgermenu-overlay {
  width: 100vw;
  height: 100vh;
  background: transparent;
  position: fixed;
  top: 0;
  right: 0;
  z-index: -1;
  transition: .3s all;
  &.active {
    z-index: 9;
    background: rgba(26, 26, 26, 0.61);
    backdrop-filter: blur(13.600000381469727px);
  }
}
@media (max-width: 650px) {
  .burgermenu {
    width: 100%;
    padding: 80px 15px 30px;
    &__menu {
      gap: 15px;
      padding: 15px 0;
    }
    &__contact {
      flex-wrap: wrap;
      justify-content: flex-end;
    }
  }
}
</style>